import React from "react";
import { Step4ScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import moment from "moment";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import { HeaderBackMusicHallWidget } from "widgets";
import { Forms, Headers, Displays, Navigations } from "components";

class Step4ScheduleReserveContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    // ดึงวันที่ห้องถูกปิด/มีคิว ล่วงหน้า 12 เดือน ไว้ระบายสีและปิดวันในปฏิทิน
    let res = await userService.GET_ROOM_AVAILABILITY_LIST(
      `?room_id=${router.params.id}&start_date=${moment().format(
        "YYYY-MM-DD",
      )}&end_date=${moment().add(12, "month").format("YYYY-MM-DD")}&pagination=false`,
    );
    this.setState({
      initialValues: {
        ...urlParams,
      },
      availabilityByDate: this.reduceAvailability(
        res?.data?.docs,
        urlParams.room_booking_id,
      ),
      isLoading: false,
    });
  };

  // [{date, reason_closed, start_time, end_time}]
  // -> { "YYYY-MM-DD": { isHoliday, isBusy, slots: [{start_time, end_time}] } }
  // เก็บช่วงเวลาไว้ด้วย เพื่อให้ฟอร์มเช็คเวลาชนได้ตั้งแต่หน้านี้ ไม่ต้องรอ error ตอน step สุดท้าย
  reduceAvailability = (docs, roomBookingId) => {
    if (!docs) return {};
    return docs.reduce((result, e) => {
      // record ของใบจองตัวเอง (ตอนแก้ไข draft) ไม่นับว่าชน - ให้ตรงกับที่ draft() ฝั่ง API ทำ
      if (
        roomBookingId &&
        String(e.room_booking_ref_id) === String(roomBookingId)
      ) {
        return result;
      }
      const key = moment(e.date).format("YYYY-MM-DD");
      if (!result[key]) {
        result[key] = { isHoliday: false, isBusy: false, slots: [] };
      }
      if (e.reason_closed === "1") {
        result[key].isHoliday = true;
      } else {
        result[key].isBusy = true;
        result[key].slots.push({
          start_time: e.start_time,
          end_time: e.end_time,
        });
      }
      return result;
    }, {});
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/3${router.location.search}`,
    );
  };

  // เช็คคิวด้วย query ชุดเดียวกับที่ draft() ใช้ฝั่ง API
  // ตรรกะต้องตรงกันเป๊ะ ไม่งั้นหน้านี้ปล่อยผ่านแล้วไปตายตอน step สุดท้ายอีก
  checkRoomAvailable = async (values) => {
    const { initialValues } = this.state;
    const { id } = this.props.router.params;
    const bookingDate = moment(values.booking_date).format("YYYY-MM-DD");
    // ห้องถูกใช้ตั้งแต่เตรียมงานถึงเก็บงาน ต้องเช็คช่วงนี้ให้ตรงกับที่ API ล็อคคิว
    const startTime = values.setup_cleanup_start_time.value;
    const endTime = values.setup_cleanup_end_time.value;
    const res = await userService.GET_ROOM_AVAILABILITY_LIST(
      `?room_id=${id}&start_date=${bookingDate}&end_date=${bookingDate}&start_time=${startTime}&end_time=${endTime}&pagination=false`,
    );
    if (!res?.data?.docs) return true; // เรียก API ไม่สำเร็จ ปล่อยให้ด่าน API ตอน step 9 ตัดสิน
    // music hall จองวันและเวลาซ้ำกันได้ จึงไม่นับคิวจอง (reason_closed 4) ว่าเป็นตัวบล็อค
    // เหลือแค่วันหยุด/ห้องปิด/ซ่อมบำรุง - ตรงกับที่ draft() ฝั่ง API ทำ
    const docs = res.data.docs.filter((e) => e.reason_closed !== "4");
    if (docs.length === 0) return true;
    // แก้ไขใบจองเดิม: record ของตัวเองในเวลาเดิมไม่นับว่าชน
    const roomBookingId = initialValues?.room_booking_id;
    if (!roomBookingId) return false;
    return docs.some(
      (e) =>
        String(e.room_booking_ref_id) === String(roomBookingId) &&
        e.start_time === startTime &&
        e.end_time === endTime,
    );
  };

  handleSubmit = async (values) => {
    const { initialValues } = this.state;
    const { t } = this.props;
    const { id } = this.props.router.params;
    this.setState({ isBgLoading: true });
    const isAvailable = await this.checkRoomAvailable(values);
    this.setState({ isBgLoading: false });
    if (!isAvailable) {
      toast.error(
        t("Room is not available on selected date/time.", { ns: "common" }),
      );
      return;
    }
    const queryString = new URLSearchParams({
      ...initialValues,
      ...values,
      setup_cleanup_start_time: values.setup_cleanup_start_time.value,
      setup_cleanup_end_time: values.setup_cleanup_end_time.value,
      event_start_time: values.event_start_time.value,
      event_end_time: values.event_end_time.value,
      // แต่ละวันสำรองมีเวลาของตัวเอง จึงเก็บเป็น JSON ใน query string
      alternative_booking_dates: JSON.stringify(
        (values.alternative_booking_dates || [])
          .filter((e) => e?.date)
          .map((e) => ({
            booking_date: moment(e.date).format("YYYY-MM-DD"),
            setup_cleanup_start_time: e.setup_cleanup_start_time?.value || "",
            setup_cleanup_end_time: e.setup_cleanup_end_time?.value || "",
            event_start_time: e.event_start_time?.value || "",
            event_end_time: e.event_end_time?.value || "",
          })),
      ),
    }).toString();
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/5?${queryString}`,
    );
  };

  render() {
    const { router, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const { availabilityByDate, isBgLoading, isLoading, initialValues } =
      this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <Step4ScheduleReserveContainerStyled isPreview={isPreview}>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              title_reserve={`2. ${t("Booking Details", { ns: "room" })}`}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Forms.MusicHallRegisBookingForm
              isDisabledForm={isPreview}
              initialValues={initialValues}
              availabilityByDate={availabilityByDate}
              onBack={this.handleBack}
              onSubmit={this.handleSubmit}
            />
          )}
        </div>
      </Step4ScheduleReserveContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(Step4ScheduleReserveContainer),
);
